// libs
import {
  PlusSquare,
  MinusSquare,
  ArrowUpRight,
  ArrowDownLeft,
} from "lucide-react";

// styles
import classes from "./styles.module.css";

export default function Action({ data }) {
  const { id, type, title, price, count, created_at } = data;
  
  const isSell = type === "sell";
  const isPurchase = type === "purchase";
  const isInvestment = type === "investment";
  const isConclusion = type === "conclusion";
  const isProduct = isSell || isPurchase;
  const isPositiveMoney = isSell || isInvestment;

  return (
    <div className={classes.root}>
      <div>
        { isSell && <ArrowUpRight className={`${classes.icon} ${classes[type]}`} size={32} stroke="#009966" />}
        { isPurchase && <ArrowDownLeft className={`${classes.icon} ${classes[type]}`} size={32} stroke="#155DFC" />}
        { isInvestment && <PlusSquare className={`${classes.icon} ${classes[type]}`}  size={32} stroke="#8477F9" />}
        { isConclusion && <MinusSquare className={`${classes.icon} ${classes[type]}`}  size={32} stroke="#EB9F4E" />}
      </div>
      
      <div>
        <p className={classes.time}>{new Date(created_at).toLocaleTimeString().split(":").splice(0, 2).join(":")}</p>
        <p className={classes.title}>{title}</p>
        { isProduct && <p className={classes.price}>{count} шт х {price} ֏</p> }
      </div>

      <div className={classes.fullPriceContainer}>
        <p className={`${classes.fullPrice} ${isPositiveMoney && classes.fullPricePositive}`}>{isPositiveMoney ? "+":"-"}{price * count} ֏</p>
        <p className={classes.date}>{new Date(created_at).toLocaleDateString().split(".").join("-")}</p>
      </div>
    </div>
  );
}